import script from "./ShopHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopHome.vue?vue&type=script&setup=true&lang=js"

import "./ShopHome.vue?vue&type=style&index=0&id=e58afc4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e58afc4c"]])

export default __exports__